import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { inputCls } from "./Fields";
import { PageTitle } from "./AdminDashboard";
import { useAdminAuth } from "./AdminAuth";

const AdminAccount = () => {
  const { user } = useAdminAuth();
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/change-password", { current_password: cur, new_password: nw }); toast.success("Password updated"); setCur(""); setNw(""); }
    catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <div data-testid="admin-account">
      <PageTitle title="Account" sub={`Signed in as ${user.email}`} />
      <form onSubmit={submit} className="max-w-md rounded-2xl bg-white border border-jannah-sand p-8 space-y-4">
        <h2 className="text-lg font-bold text-jannah-ink">Change password</h2>
        <div><label className="block text-xs font-semibold uppercase tracking-wide text-jannah-ink/60 mb-1.5">Current password</label><input type="password" required value={cur} onChange={(e) => setCur(e.target.value)} className={inputCls} data-testid="account-current-password" /></div>
        <div><label className="block text-xs font-semibold uppercase tracking-wide text-jannah-ink/60 mb-1.5">New password (min 8 chars)</label><input type="password" required minLength={8} value={nw} onChange={(e) => setNw(e.target.value)} className={inputCls} data-testid="account-new-password" /></div>
        <button type="submit" className="px-6 py-2.5 rounded-md bg-jannah-gold text-white text-sm font-bold uppercase tracking-wider hover:bg-jannah-green" data-testid="account-save">Update password</button>
      </form>
    </div>
  );
};

export default AdminAccount;
